import { useParams } from 'react-router-dom';
const useDetail = () => {
  const params = useParams();

  return {
    hasRequestSeq: params.requestSeq !== '0',
    hasPreRequestDtlNo: !!params?.preRequestDtlNo,
  };
};

export default useDetail;
